import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [userID, setUserID] = useState(localStorage.getItem("UserID"));

  useEffect(() => {
    localStorage.setItem("UserID", userID);
  }, [userID]);

  const values = {
    setUserID,
    userID,
  };

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
};

const useAuth = () => useContext(AuthContext);
export { AuthProvider, useAuth };
